var map = {
	"./years-of-experience-en.png": "BeUn",
	"./years-of-experience-fr.png": "6r05"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8hcl";


//////////////////
// WEBPACK FOOTER
// ./src/assets/complete ^\.\/years\-of\-experience\-.*\.png$
// module id = 8hcl
// module chunks = 0